import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {
  citizenGetServicesAutomationDetails
} from 'src/app/store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.actions';
import {
  CitizensServicesAutomationDetails
} from 'src/app/store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.model';
import {
  selectModifiedCitizenServicesAutomation
} from 'src/app/store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.selectors';
import {
  citizenGetServicesDeliveryChannels
} from 'src/app/store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.actions';
import {
  CitizensServicesDeliveryChannel
} from 'src/app/store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.model';
import {
  selectCitizenServiceDeliveryChannel
} from 'src/app/store/entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.selectors';
import {
  citizenGetServicesRequirements
} from 'src/app/store/entities/citizens/citizens-services-requirements/citizens-services-requirements.actions';
import {
  CitizensServicesRequirements
} from 'src/app/store/entities/citizens/citizens-services-requirements/citizens-services-requirements.model';
import {
  selectModifiedServiceRequirement
} from 'src/app/store/entities/citizens/citizens-services-requirements/citizens-services-requirements.selectors';
import {citizenGetServices} from 'src/app/store/entities/citizens/citizens-services/citizens-services.actions';
import {CitizensServices} from 'src/app/store/entities/citizens/citizens-services/citizens-services.model';
import {
  selectModifiedCitizensByServiceUniqueId
} from 'src/app/store/entities/citizens/citizens-services/citizens-services.selectors';
import {
  citizenGetInstitutionServiceBillings
} from 'src/app/store/entities/service-management/service-billing-detail/service-billing-detail.actions';
import {
  ServiceBillingDetail
} from 'src/app/store/entities/service-management/service-billing-detail/service-billing-detail.model';
import {
  selectAllServiceBillingDetails
} from 'src/app/store/entities/service-management/service-billing-detail/service-billing-detail.selectors';
import {
  citizenGetInstitutionServiceFormulaBasedSchemes,
  clearServiceFormulaSchemes
} from 'src/app/store/entities/service-management/service-formula-scheme/service-formula-scheme.actions';
import {
  ServiceFormulaScheme
} from 'src/app/store/entities/service-management/service-formula-scheme/service-formula-scheme.model';
import {
  selectAllServiceFormulaSchemes
} from 'src/app/store/entities/service-management/service-formula-scheme/service-formula-scheme.selectors';
import {AppState} from 'src/app/store/reducers';
import {Apollo} from "apollo-angular";
import {CITIZEN_UPADATE_POPULAR_SERVICE} from './popular-service';
import {BillingSchemeEnum} from 'src/app/interfaces/global.interface';
import {
  citizenGetInstitutionServicePercentageSchemes,
  clearServicePercentageSchemes
} from 'src/app/store/entities/service-management/service-percentage-scheme/service-percentage-scheme.actions';
import {
  citizenGetInstitutionServiceCatalogSchemes,
  clearServiceCatalogSchemes
} from 'src/app/store/entities/service-management/service-catalog-scheme/service-catalog-scheme.actions';
import {
  citizenGetInstitutionServiceDirectCostSchemes,
  clearServiceDirectCosts
} from 'src/app/store/entities/service-management/service-direct-cost/service-direct-cost.actions';
import {
  ServicePercentageScheme
} from 'src/app/store/entities/service-management/service-percentage-scheme/service-percentage-scheme.model';
import {
  selectAllServicePercentageSchemes
} from 'src/app/store/entities/service-management/service-percentage-scheme/service-percentage-scheme.selectors';
import {
  ServiceCatalogScheme
} from 'src/app/store/entities/service-management/service-catalog-scheme/service-catalog-scheme.model';
import {
  selectAllServiceCatalogSchemes
} from 'src/app/store/entities/service-management/service-catalog-scheme/service-catalog-scheme.selectors';
import {
  ServiceDirectCost
} from 'src/app/store/entities/service-management/service-direct-cost/service-direct-cost.model';
import {
  selectModifiedServiceDirectCosts
} from 'src/app/store/entities/service-management/service-direct-cost/service-direct-cost.selectors';
import {CITIZEN_GET_EXCHANGE_CURRENCY_COST} from './exchage-currency';
import {environment} from 'src/environments/environment.prod';
import {Location} from '@angular/common';
import {getAllOfficeBranch} from "../../../store/entities/instution-settings/branch-office/branch-office.actions";
import {BranchOffice} from "../../../store/entities/instution-settings/branch-office/branch-office.model";
import {selectAllBranchOffices} from "../../../store/entities/instution-settings/branch-office/branch-office.selectors";


@Component({
  selector: 'app-service-view',
  templateUrl: './service-view.component.html',
  styleUrls: ['./service-view.component.scss']
})
export class ServiceViewComponent implements OnInit {
  title: string;
  allStatus: {
    name: string,
    icon: string
  }[]

  fileServer: string = environment.FILE_SERVER_URL

  socialMediaLinks = [
    {
      name: 'Instagram',
      icon: 'instagram_coloured',
      link: 'https://www.instagram.com'
    },
    {
      name: 'X',
      icon: 'x',
      link: 'https://x.com',
    },
    {
      name: 'Youtube',
      icon: 'youtube_coloured',
      link: 'https://www.youtube.com'
    },
    {
      name: "Oxygen",
      icon: 'oxygen',
      link: 'https://www.maadili.go.tz'
    }
  ]

  currentTabIndex = 0;
  service$: Observable<CitizensServices>;
  requirements$: Observable<CitizensServicesRequirements []>;
  servicesAutomations$: Observable<CitizensServicesAutomationDetails[]>;
  deliveryChannels$: Observable<CitizensServicesDeliveryChannel[]>;
  billings$: Observable<ServiceBillingDetail[]>;
  formularScheme$: Observable<ServiceFormulaScheme[]>;
  percentageScheme$: Observable<ServicePercentageScheme[]>;
  catalogScheme$: Observable<ServiceCatalogScheme[]>;
  directCostScheme$: Observable<ServiceDirectCost[]>;

  convertedValue: number = null
  convertedCurrency: string = ''
  serviceUniqueId: string;
  branchOffice$: Observable<BranchOffice[]>
  groupTypeString: string = '';

  constructor(
    private readonly store: Store<AppState>,
    private readonly route: ActivatedRoute,
    private readonly apollo: Apollo,
    private readonly location: Location
  ) {
    this.serviceUniqueId = this.route.snapshot.paramMap.get('serviceUniqueId');
    this.store.dispatch(getAllOfficeBranch({
      filtering: {
        serviceUniqueId: this.serviceUniqueId
      }
    }))
    this.getData();
  }

  ngOnInit() {
    this.title = 'Service Categories';

    this.allStatus = [
      {
        name: "Taarifa za malipo",
        icon: 'cost'
      },
      {
        name: "Mchakato wa huduma",
        icon: 'list'
      },
      {
        name: "Omba huduma",
        icon: 'request-quote'
      },
      {
        name:"Tuma Mrejesho",
        icon: 'feedback'
      }
    ]

    this.citizenUpdatePopularServiceMutation()

    this.service$ = this.store.select(selectModifiedCitizensByServiceUniqueId(this.serviceUniqueId));
    this.servicesAutomations$ = this.store.select(selectModifiedCitizenServicesAutomation)
    this.deliveryChannels$ = this.store.select(selectCitizenServiceDeliveryChannel);

    this.service$.subscribe((service) => {
      if (service?.serviceGroups?.length) {
        this.groupTypeString = service.serviceGroups.map(g => g.groupType).join(', ');
      } else {
        this.groupTypeString = '-';
      }
    });
    this.requirements$ = this.store.select(selectModifiedServiceRequirement);
    this.billings$ = this.store.select(selectAllServiceBillingDetails);

    // BEGIN: service catalog scheme
    this.store.select(selectAllServiceCatalogSchemes);
    // END: Service Catalog scheme

    this.branchOffice$ = this.store.select(selectAllBranchOffices);

    this.formularScheme$ = this.store.select(selectAllServiceFormulaSchemes);
    this.percentageScheme$ = this.store.select(selectAllServicePercentageSchemes);
    this.catalogScheme$ = this.store.select(selectAllServiceCatalogSchemes);
    this.directCostScheme$ = this.store.select(selectModifiedServiceDirectCosts);

  }


  goBack() {
    this.location.back()
  }

  getData() {
    this.store.dispatch(citizenGetServicesRequirements({serviceUniqueId: this.serviceUniqueId}));

    this.store.dispatch(citizenGetServices({
      filtering: {
        serviceUniqueId: this.serviceUniqueId, pageNumber: 1, itemsPerPage: 1
      }
    }));
    this.store.dispatch(citizenGetServicesAutomationDetails({filtering: {serviceUniqueId: this.serviceUniqueId}}));
    this.store.dispatch(citizenGetInstitutionServiceBillings({filtering: {serviceUniqueId: this.serviceUniqueId}}));
    this.store.dispatch(citizenGetServicesDeliveryChannels({serviceUniqueId: this.serviceUniqueId}));
  }

  loadmore(billing) {
    switch (billing?.billingScheme) {
      case BillingSchemeEnum.FORMULAR_BASED:
        this.store.dispatch(clearServiceDirectCosts())
        this.store.dispatch(clearServiceFormulaSchemes())
        this.store.dispatch(clearServiceCatalogSchemes())
        this.store.dispatch(citizenGetInstitutionServiceFormulaBasedSchemes({billingUniqueId: billing?.billingUniqueId}))
        break;

      case BillingSchemeEnum.PERCENTAGE_BASED:
        this.store.dispatch(clearServiceFormulaSchemes())
        this.store.dispatch(clearServiceDirectCosts())
        this.store.dispatch(clearServiceFormulaSchemes())
        this.store.dispatch(citizenGetInstitutionServicePercentageSchemes({billingUniqueId: billing?.billingUniqueId}))
        break;

      case BillingSchemeEnum.CATALOGY_BASED:
        this.store.dispatch(clearServiceDirectCosts())
        this.store.dispatch(clearServicePercentageSchemes())
        this.store.dispatch(clearServiceFormulaSchemes())
        this.store.dispatch(citizenGetInstitutionServiceCatalogSchemes({billingUniqueId: billing?.billingUniqueId}))
        break;

      case BillingSchemeEnum.DIRECT_COST:
        this.store.dispatch(clearServiceCatalogSchemes())
        this.store.dispatch(clearServicePercentageSchemes())
        this.store.dispatch(clearServiceFormulaSchemes())
        this.store.dispatch(citizenGetInstitutionServiceDirectCostSchemes({billingUniqueId: billing?.billingUniqueId}))
        break;

      case BillingSchemeEnum.NO_COST:
        break;
    }

  }

  tabController(index) {
    this.currentTabIndex = index;
  }


  citizenUpdatePopularServiceMutation() {
    this.apollo.mutate({
      mutation: CITIZEN_UPADATE_POPULAR_SERVICE,
      fetchPolicy: 'network-only',
      variables: {
        serviceUniqueId: this.serviceUniqueId
      }
    }).toPromise().then((data) => {
      let result: any = Object.values(data)[0]
      result = result.citizenUpdatePopularServiceMutation
      if (result?.response.code == '9000') {
        console.log(result.data)
      }
    })
  }

  exchangeCurrency(currentCurrency: string, amountToChange: number) {
    this.apollo.query({
      query: CITIZEN_GET_EXCHANGE_CURRENCY_COST,
      fetchPolicy: 'network-only',
      variables: {
        exchange: {
          currentCurrency: currentCurrency,
          amountToChange: amountToChange
        }
      }
    }).toPromise().then((data) => {
      let result: any = Object.values(data)[0]
      result = result.citizenGetExchangedCurrencyCost

      let that = this

      if (result?.response.code == '9000') {
        that.convertedCurrency = result.data.currentCurrency
        that.convertedValue = result.data.amountFromChange
      }
    })
  }

}
